import * as React from 'react';

import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import { SeatingOption, SeatingOptionGroup } from '../../../classes/seating-option';

import CheckBoxGroup from '../../../common/checkbox/checkbox-group';
import RadioGroup from '../../../common/radio/radio-group';

export interface ISeatInfoOptionsProps {
    seatingOptionGroup: SeatingOptionGroup;
    appSettingsModel: IAppSettingsModel;
    onSelectSeatingOption: (seatingOptions: SeatingOption[], groupId: string) => void;
    selectedSeatingOptions: Array<SeatingOption>;
    requestingSeatView: boolean;
    isGAZone?: boolean;
}

class SeatInfoOptions extends React.Component<ISeatInfoOptionsProps, any>{
    static defaultProps = {
        isGAZone: false
    }

    render() {

        if (this.props.seatingOptionGroup == null) {
            return null;
        }

        return (
            <div className="seat-info-options">
                {
                    // For each seating group, create radio buttons.
                    !this.props.seatingOptionGroup.isCheckbox ?
                        <RadioGroup disabled={false} key={this.props.seatingOptionGroup.id} id={this.props.seatingOptionGroup.id}
                            stateChangeFunction={this.props.onSelectSeatingOption.bind(this)}
                            selectedOptions={this.props.selectedSeatingOptions} group={this.props.seatingOptionGroup} />
                        :
                        <CheckBoxGroup key={this.props.seatingOptionGroup.id} id={this.props.seatingOptionGroup.id}
                            stateChangeFunction={this.props.onSelectSeatingOption}
                            selectedOptions={this.props.selectedSeatingOptions} group={this.props.seatingOptionGroup}
                            allText="" showAllOption={false}
                        />
                }
            </div>
        );
    }
}

export default SeatInfoOptions;